import { CHARACTERS_SERVICE } from "@/services/characters.service.js";

const state = {postCharacterOutput: false, getCharactersOutput: {}, getCharacterByIdOutput: {}, deleteCharacterByIdOutput: false, putCharacterOutput: false};

const actions = {
    //Service to create characters
    postCharacter({ dispatch, commit }, input) {
        dispatch('alert/clear', null, { root: true });
        commit('postCharacterRequest');

        CHARACTERS_SERVICE.postCharacter(input)
            .then(
                output => {
                    commit('postCharacterSuccess', output);
                },
                error => {
                    commit('postCharacterFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to get paginated characters
    getCharacters({ dispatch, commit }, queryParams) {
        dispatch('alert/clear', null, { root: true });
        commit('getCharactersRequest');

        CHARACTERS_SERVICE.getCharacters(queryParams)
            .then(
                output => {
                    commit('getCharactersSuccess', output);
                },
                error => {
                    commit('getCharactersFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to get characters details
    getCharacterById({ dispatch, commit }, id) {
        dispatch('alert/clear', null, { root: true });
        commit('getCharacterByIdRequest');

        CHARACTERS_SERVICE.getCharacterById(id)
            .then(
                output => {
                    commit('getCharacterByIdSuccess', output);
                },
                error => {
                    commit('getCharacterByIdFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },

    //Service to delete characters
    deleteCharacterById({ dispatch, commit }, id) {
        dispatch('alert/clear', null, { root: true });
        commit('deleteCharacterByIdRequest');

        CHARACTERS_SERVICE.deleteCharacterById(id)
            .then(
                output => {
                    commit('deleteCharacterByIdSuccess', output);
                },
                error => {
                    commit('deleteCharacterByIdFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    },
    putCharacter({ dispatch, commit }, input) {
        dispatch('alert/clear', null, { root: true });
        commit('putCharacterRequest');

        CHARACTERS_SERVICE.putCharacter(input)
            .then(
                output => {
                    commit('putCharacterSuccess', output);
                },
                error => {
                    commit('putCharacterFailure', error);
                    dispatch('alert/error', error, { root: true });
                }
            );
    }

};

const mutations = {
    //postCharacter
    postCharacterRequest(state) {
        state.postCharacterOutput = null;
    },
    postCharacterSuccess(state, output) {
        state.postCharacterOutput = true;
    },
    postCharacterFailure(state) {
        state.postCharacterOutput = false;
    },

    //getCharacters
    getCharactersRequest(state) {
    },
    getCharactersSuccess(state, output) {
        state.getCharactersOutput = output;
    },
    getCharactersFailure(state) {
        state.getCharactersOutput = false;
    },

    //getCharacterById
    getCharacterByIdRequest(state) {
    },
    getCharacterByIdSuccess(state, output) {
        state.getCharacterByIdOutput = output;
    },
    getCharacterByIdFailure(state) {
        state.getCharacterByIdOutput = false;
    },

    //deleteCharacterById
    deleteCharacterByIdRequest(state) {
        state.deleteCharacterByIdOutput = null;
    },
    deleteCharacterByIdSuccess(state, output) {
        state.deleteCharacterByIdOutput = true;
    },
    deleteCharacterByIdFailure(state) {
        state.deleteCharacterByIdOutput = false;
    },

    // putCharacter
    putCharacterRequest(state) {
        state.putCharacterOutput = null;
    },
    putCharacterSuccess(state, output) {
        state.putCharacterOutput = true;
    },
    putCharacterFailure(state) {
        state.putCharacterOutput = false;
    }
};

export const characters = {
    namespaced: true,
    state,
    actions,
    mutations
};